<script setup lang="ts">
import type { BreadcrumbItem } from "@nuxt/ui";
import { getArticleDetail } from "@carnet/api/backoffice";

definePageMeta({
  layout: "app",
});

const route = useRoute();
const localePath = useLocalePath();
const slug = route.params.slug as string;

const { data, error } = await useAsyncData(`page-${slug}`, () =>
  getArticleDetail({
    composable: "$fetch",
    path: { locale: appLocale(), code: slug },
    headers: { Accept: "application/json" },
  })
);

if (error.value || !data.value?.data) {
  throw createError({ statusCode: 404, statusMessage: "Page non trouvée" });
}

const article = data.value.data;

useSeoMeta({
  title: article.title,
  description: article.content || article.title,
});
useSeoImage(seoImageFrom(article.mainImage, article.title));

useJsonLd({
  "@type": "Article",
  headline: article.title,
  description: metaDescription(article.content),
  image: article.mainImage?.url,
  datePublished: article.publicationDate || undefined,
});

const breadcrumb: BreadcrumbItem[] = [{ label: "Accueil", to: localePath({ name: "index" }) }, { label: article.title }];
</script>

<template>
  <AppArticleContent :article="article">
    <WebBreadcrumbs :items="breadcrumb" class="mb-8 md:mb-10" />
  </AppArticleContent>
</template>
